import React, { useState } from "react";
import { Button } from "react-bootstrap";
import "../Followup/AnnualMaskPurchaseGuide.css";
import "./StepByStepGuide.css";

const UI = {
  TH: {
    navigation: "ขั้นตอนการใช้งาน", start: "ก่อนเริ่ม", intro: "เริ่มต้นใช้งาน",
    step: "ขั้นตอน", of: "จาก", previous: "ก่อนหน้า", next: "ขั้นตอนถัดไป",
    back: "กลับไปก่อนเริ่ม", reference: "ข้อมูลเพิ่มเติม", language: "ภาษา",
  },
  EN: {
    navigation: "Workflow steps", start: "Before you start", intro: "Getting started",
    step: "Step", of: "of", previous: "Previous", next: "Next step",
    back: "Back to preparation", reference: "Reference", language: "Language",
  },
};

// Uses the Annual Mask guide's layout and styling for other operator guides.
const StepByStepGuide = ({ copy, language, onLanguageChange, eyebrow, actions, selector }) => {
  const [activeStep, setActiveStep] = useState(-1);
  const ui = UI[language];
  const step = activeStep >= 0 ? copy.steps[activeStep] : null;

  return (
    <div className="annual-mask-guide step-by-step-guide" lang={language === "TH" ? "th" : "en"}>
      <header className="amg-header">
        <div>
          <div className="amg-eyebrow">{eyebrow}</div>
          <h2>{copy.title}</h2>
          <p>{copy.subtitle}</p>
        </div>
        <div className="amg-header-actions">
          <div className="amg-language" role="group" aria-label={ui.language}>
            {["TH", "EN"].map((value) => (
              <button key={value} type="button" className={language === value ? "is-active" : ""} aria-pressed={language === value} onClick={() => onLanguageChange(value)}>
                {value === "TH" ? "TH · ไทย" : "EN · English"}
              </button>
            ))}
          </div>
          {actions}
        </div>
      </header>

      {selector}

      <div className="amg-layout">
        <nav className="amg-navigation" aria-label={ui.navigation}>
          <div className="amg-nav-label">{ui.navigation}</div>
          <button type="button" className={`amg-nav-item ${activeStep === -1 ? "is-active" : ""}`} aria-current={activeStep === -1 ? "step" : undefined} onClick={() => setActiveStep(-1)}>
            <span className="amg-step-number">◎</span>
            <span>{ui.start}<small>{ui.intro}</small></span>
          </button>
          {copy.steps.map((item, index) => (
            <button key={index} type="button" className={`amg-nav-item ${activeStep === index ? "is-active" : ""}`} aria-current={activeStep === index ? "step" : undefined} onClick={() => setActiveStep(index)}>
              <span className="amg-step-number">{index + 1}</span>
              <span>{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="amg-reading-column">
          <article className="amg-article" aria-labelledby="operator-guide-step-title" aria-live="polite">
            <div className="amg-article-heading">
              <div className="amg-step-meta">
                <span>{step ? `${ui.step} ${activeStep + 1} ${ui.of} ${copy.steps.length}` : ui.intro}</span>
                {step && step.status && <span className="amg-optional">{step.status}</span>}
              </div>
              <h3 id="operator-guide-step-title">{step ? step.title : ui.start}</h3>
              {!step && <p>{copy.introText}</p>}
            </div>
            <div className="amg-instructions">
              {!step && <div className="amg-preparation-label">{copy.count}</div>}
              <ol className="amg-instruction-list">
                {(step ? step.items : copy.preparation).map((item, index) => <li key={index}>{item}</li>)}
              </ol>
              {step && step.content && <div className="guide-step-content">{step.content}</div>}
            </div>
            <footer className="amg-step-footer">
              <Button variant="outline-secondary" size="sm" disabled={activeStep === -1} onClick={() => setActiveStep(activeStep - 1)}>← {ui.previous}</Button>
              <span>{step ? `${activeStep + 1} / ${copy.steps.length}` : ui.intro}</span>
              <Button variant="primary" size="sm" onClick={() => setActiveStep(activeStep === copy.steps.length - 1 ? -1 : activeStep + 1)}>{activeStep === copy.steps.length - 1 ? ui.back : ui.next} →</Button>
            </footer>
          </article>

          <section className="amg-reference" aria-label={ui.reference}>
            {copy.references.map((reference, index) => (
              <details key={index}>
                <summary>{reference.title}</summary>
                {reference.items && <ul>{reference.items.map((item, itemIndex) => <li key={itemIndex}>{item}</li>)}</ul>}
                {reference.content}
              </details>
            ))}
          </section>
        </div>
      </div>
    </div>
  );
};

export default StepByStepGuide;
